import track from './track';
export const analyticsMiddleware = () => (next) => (action) => {
    track(action);
    return next(action);
};
